export const writeInt32 = (
  view: DataView,
  offset: number,
  value: number,
  littleEndian = true,
): void => {
  view.setInt32(offset, value, littleEndian);
};

export const writeDouble = (
  view: DataView,
  offset: number,
  value: number,
  littleEndian = true,
): void => {
  view.setFloat64(offset, value, littleEndian);
};
